var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-info-label", {
                    attrs: {
                      label: _vm.$ct("description"),
                      value: _vm.task.Text,
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-info-label", {
                    attrs: {
                      label: _vm.$ct("assigned-users"),
                      value: _vm.assignedUsers,
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-info-label", {
                    attrs: {
                      label: _vm.$ct("due-date"),
                      value: _vm.dueDateString,
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-info-label", {
                    attrs: {
                      label: _vm.$ct("status"),
                      value: _vm.statusString,
                    },
                  }),
                ],
                1
              ),
              _vm.folder.Folder
                ? _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("app-info-label", {
                        attrs: {
                          label: _vm.$ct("folder"),
                          value: _vm.folder.Folder.Name,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }